import { List } from 'immutable';
import BaseList from 'records/BaseList';

import {
  MENU_CANDIDATE_CATEGORIES_ASYNC_ACTION_START,
  MENU_CANDIDATE_CATEGORIES_ASYNC_ACTION_ERROR,
  MENU_CANDIDATE_CATEGORIES_ASYNC_ACTION_SUCCESS,
  MENU_CANDIDATE_CATEGORIES_RESET_STATE,
} from 'actions/menuCandidateCategories';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [MENU_CANDIDATE_CATEGORIES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [MENU_CANDIDATE_CATEGORIES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [MENU_CANDIDATE_CATEGORIES_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new List(action.data),
    });
  },
  [MENU_CANDIDATE_CATEGORIES_RESET_STATE]: () => {
    return initialState;
  },
}

export default function menuCandidateCategories(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
